import { auth, db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

// Read endpoint from environment
const NOTES_API = process.env.REACT_APP_NOTES_API;

// Track in-flight notes requests per contentId to ensure only one request at a time
const inFlightNotesRequests = new Map();
export const isNotesRequestInFlight = (contentId) => inFlightNotesRequests.has(contentId);

export async function generateNotesForSession(contentId, title = '') {
  if (!contentId) throw new Error("Missing contentId for notes generation");

  if (inFlightNotesRequests.has(contentId)) {
    return inFlightNotesRequests.get(contentId);
  }

  const promise = (async () => {
    try {
      if (!NOTES_API) {
        throw new Error('Notes API endpoint not configured. Set REACT_APP_NOTES_API in .env');
      }
      const user = auth.currentUser;
      let token = null;
      if (user) {
        token = await user.getIdToken();
      }

      const payload = { contentId, title };

      const resp = await fetch(NOTES_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify(payload)
      });

      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error(`Notes API error: ${resp.status} ${txt}`);
      }

      const data = await resp.json();
      if (!data || data.success === false) {
        throw new Error(`Notes API failed: ${JSON.stringify(data)}`);
      }

      const notesObj = {
        lesson_title: data.lesson_title || title || "Study Notes",
        notes: data.notes || ""
      };

      return notesObj;
    } finally {
      inFlightNotesRequests.delete(contentId);
    }
  })();

  inFlightNotesRequests.set(contentId, promise);
  return promise;
}

export async function fetchLatestNotes(contentId) {
  try {
    const user = auth.currentUser;
    if (!user || !contentId) return null;
    const notesCol = collection(db, 'users', user.uid, 'Sessions', contentId, 'Notes');
    const q = query(notesCol, orderBy('timestamp', 'desc'));
    const snap = await getDocs(q);
    if (!snap || snap.empty) return null;
    const latest = snap.docs[0];
    const data = latest.data() || {};
    return { id: latest.id, notesObj: { lesson_title: data.lesson_title, notes: data.notes }, timestamp: data.timestamp ?? null };
  } catch (e) {
    return null;
  }
}
